// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Modal0 from "../common/Modal0.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import HelpOutline from "@mui/icons-material/HelpOutline";

var portalLabels = [
  "Other",
  "TFT_Portals_Headliner_Superstar",
  "TFT_Portals_Combat_TrainingDummy",
  "TFT_Portals_Items_ArtifactAnvil",
  "TFT_Portals_Items_RadiantItem",
  "TFT_Portals_Unique_Spatula",
  "TFT_Portals_Items_TacticiansCrown",
  "TFT_Portals_Items_SupportAnvil",
  "TFT_Portals_Combat_WanderingTrainers"
];

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Portal");
        }), "!pl-6", (function (param, param$1, param$2) {
          return React.createElement("div", {
                      className: "truncate"
                    }, param$2.t(Belt_Array.getExn(portalLabels, param[0])));
        }), "!pl-6", undefined, undefined, (function (param, param$1, param$2) {
          return param$2.t(Belt_Array.getExn(portalLabels, param[0]));
        }), undefined, 130, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Games");
        }), undefined, (function (param, param$1, param$2) {
          return T.humanReadableCount(param[1]);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[0];
        }), undefined, 80, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Play Rate");
        }), undefined, (function (param, param$1, param$2) {
          return Global.formatPct2(undefined, Global.f(param[1]) / Global.f(param$1[0]));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[0];
        }), undefined, 80, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (param, param$1, param$2) {
          return Global.toFixed(undefined, Global.f(param[2]) / Global.f(param[1]));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return Global.f(param[2]) / Global.f(param[1]);
        }), undefined, 80, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Delta");
        }), "!pr-6", (function (param, param$1, param$2) {
          var count = param[1];
          var delta = (Global.f(param[2]) / Global.f(count) - param$1[1]) / (1 - Global.f(count) / Global.f(param$1[0]));
          return Global.toFixed(undefined, delta);
        }), "!pr-6", undefined, undefined, (function (param, param$1, param$2) {
          var count = param[1];
          return (Global.f(param[2]) / Global.f(count) - param$1[1]) / (1 - Global.f(count) / Global.f(param$1[0]));
        }), undefined, 80, undefined, undefined)
];

function Tc2Portals(Props) {
  var group = Props.group;
  var keyFn = React.useCallback((function (param) {
          return String(param[0]);
        }), []);
  var portals = React.useMemo((function () {
          return Belt_Array.keep(group.portals, (function (param) {
                        return param[0] > 0;
                      }));
        }), [group.portals]);
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "flex items-center gap-1 pb-3"
                }, React.createElement("h3", {
                      className: "h4"
                    }, "Stats by Region/Portal"), React.createElement(Tooltip.make, {
                      title: React.createElement("div", {
                            className: "flex flex-col gap-2"
                          }, React.createElement("div", undefined, "Portals are not present in the Riot's API data but are determined from Ryze variations present in the game as well as special features of the game in players' units/traits/items. For example if everyone has 2 Tactician's Crowns, that means the game probably took place in Marus Omegnum."), React.createElement("div", undefined, "This way of determining portals is not perfectly accurate but should produce statistically relevant results. One caveat is that this process will result in inflated playrates for Ryze given some of regions/portals can not be determined if no one played Ryze during the game."), React.createElement("div", undefined, "The way it is done is specific portals are separated from unknown games in certain region. For example, House Lightshield will show all games in House Lightshield portal, while the Demacia filter will show all games in Demacia region except the ones that are known to be in House Lightshield portal.")),
                      children: React.createElement(HelpOutline, {
                            fontSize: "small"
                          })
                    })), React.createElement("div", {
                  className: "mx-[-20px]"
                }, React.createElement(StatsTable2.make, {
                      cols: cols,
                      data: portals,
                      context: [
                        group.count,
                        group.place
                      ],
                      keyFn: keyFn,
                      top: "tm40",
                      scrollEl: [
                        Modal0.modalScrollEl(),
                        0
                      ]
                    })));
}

var make = Tc2Portals;

export {
  portalLabels ,
  cols ,
  make ,
  
}
/* cols Not a pure module */
